"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextArea = function (_a) {
    return null;
};
exports.TextArea.displayName = "TextArea";
